import { AloActivity } from './AloActivity'
import { AloBase, getDefaultAloBase } from './AloBase'


export interface AloContact extends AloBase { 
    ctcLu:boolean
    ctcDatadd:string
    ctcMail:string
    acyIds:Array<AloActivity>
    ctcMessage:string
    mtpId:number|null
}

export const getDefaultAloContact = ():AloContact => {
    return {  
        ...getDefaultAloBase(),
        ctcLu:false,  
        ctcDatadd:'',
        ctcMail:'',
        acyIds:[],
        ctcMessage:'',
        mtpId:null
    }
}

export const cleanAloContact = (contact:AloContact) => {
    if(!contact) return    
    if(!contact.id) delete contact.id
    if(!contact.mtpId) delete contact.mtpId
}